import { useMutation } from "@tanstack/react-query";

import { queryClient } from "@config/queryClient";
import feedbackService from "@services/feedback.service";
import ToastService from "@services/toast.service";
import { ERROR_STRINGS } from "@config/messages";
import { useBugsnagErrorHandler } from "@hooks/useBugsnagErrorHandler";
import { CREATE_FEEDBACK_MUTATION_KEY, THREAD_AI_CONTEXT_QUERY_KEY } from "@config/query";
import type {
  IThreadAIContextResponse,
  ISubmitFeedbackPayload,
} from "@interfaces/thread.interface";

export function useCreateFeedback(threadId: string) {
  const { notifyBugsnag } = useBugsnagErrorHandler();

  return useMutation({
    mutationKey: [CREATE_FEEDBACK_MUTATION_KEY],
    mutationFn: (payload: ISubmitFeedbackPayload) =>
      feedbackService.createThreadContextFeedback(payload),
    onSuccess: (data) => {
      queryClient.setQueryData<IThreadAIContextResponse>(
        [THREAD_AI_CONTEXT_QUERY_KEY, threadId],
        (old) => (old ? { ...old, feedback: data } : old)
      );
    },
    onError: (error) => {
      notifyBugsnag(error, ERROR_STRINGS.SEND_AI_CONTEXT_FEEDBACK);
      ToastService.showError(ERROR_STRINGS.SEND_AI_CONTEXT_FEEDBACK);
    },
  });
}
